var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "语音问诊",
        visible: _vm.show,
        width: "640px",
        "close-on-click-modal": false,
        modal: false,
        "custom-class": "voice-consultation-modal",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isUploading,
              expression: "isUploading",
            },
          ],
          staticClass: "voice-modal-body",
        },
        [
          _c(
            "div",
            { staticClass: "voice-status" },
            [
              _c(
                "el-tag",
                {
                  attrs: {
                    type: _vm.statusTagType,
                    size: "small",
                    effect: "light",
                  },
                },
                [
                  _c("i", { class: _vm.statusIcon }),
                  _vm._v(" " + _vm._s(_vm.statusText) + " "),
                ]
              ),
              _vm.isRecording
                ? _c("span", { staticClass: "record-timer" }, [
                    _vm._v(_vm._s(_vm.recordTimer)),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "voice-control" }, [
            _c(
              "div",
              {
                staticClass: "record-btn-wrapper",
                on: { click: _vm.toggleRecording },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "record-btn",
                    class: { recording: _vm.isRecording },
                  },
                  [
                    _c("i", {
                      class: _vm.isRecording
                        ? "el-icon-video-pause"
                        : "el-icon-microphone",
                    }),
                  ]
                ),
              ]
            ),
            _c("p", { staticClass: "record-tip" }, [
              _vm._v(
                _vm._s(
                  _vm.isRecording
                    ? "正在聆听，点击停止"
                    : "点击麦克风开始语音问诊"
                )
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "voice-text" },
            [
              _c("div", { staticClass: "section-label" }, [_vm._v("识别内容")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: "语音内容将实时显示在这里，您也可以直接编辑修改",
                  resize: "none",
                },
                model: {
                  value: _vm.finalResult,
                  callback: function ($$v) {
                    _vm.finalResult = $$v
                  },
                  expression: "finalResult",
                },
              }),
              _vm.interimResult
                ? _c("div", { staticClass: "interim-hint" }, [
                    _c("i", { staticClass: "el-icon-loading" }),
                    _vm._v(" " + _vm._s(_vm.interimResult) + " "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.diagnosisResult
            ? _c("div", { staticClass: "voice-result" }, [
                _c("div", { staticClass: "result-header" }, [
                  _c("i", { staticClass: "el-icon-first-aid-kit" }),
                  _c("span", [_vm._v("智能诊断结果")]),
                ]),
                _c("div", { staticClass: "result-body" }, [
                  _c("div", { staticClass: "result-row" }, [
                    _c("label", [_vm._v("中医病：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.diagnosisResult.chDiagName || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "result-row" }, [
                    _c("label", [_vm._v("主诉词：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.diagnosisResult.symptomText || "-")),
                    ]),
                  ]),
                  _vm.diagnosisResult.matchedSymList &&
                  _vm.diagnosisResult.matchedSymList.length
                    ? _c("div", { staticClass: "result-row" }, [
                        _c("label", [_vm._v("匹配症状：")]),
                        _c(
                          "div",
                          { staticClass: "sym-tags" },
                          _vm._l(
                            _vm.diagnosisResult.matchedSymList,
                            function (sym, idx) {
                              return _c(
                                "el-tag",
                                {
                                  key: idx,
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    effect: "plain",
                                  },
                                },
                                [_vm._v(" " + _vm._s(sym.name) + " ")]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.isUploading,
                disabled: !_vm.canSubmit,
              },
              on: { click: _vm.handleConfirm },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.diagnosisResult ? "确认并填充" : "提交识别") +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }